<template>
  <div class="sns_box">
    <div @click="openUrl(icon.i_url)" class="sns_box_link" v-for="icon in iconList" :key="`icon${icon.i_idx}`"
         :style="`background-image:url(${returnIconImage(icon)})`"></div>
  </div>
</template>

<script>
import imageOption from "@/mixins/imageOption";
import util from "@/mixins/util";

export default {
  name: "WebLinkListComponent",
  mixins: [imageOption],
  props: {},
  data() {
    return {
      iconList: [],
    }
  },
  created() {

  },
  mounted() {
    this.getIcon()
  },
  computed: {},
  methods: {
    getIcon() {
      let params = {}
      try {
        this.$api.$icon.getWebIcon(params).then(res => res.Data.Result).then(res => {
          if (res.Info.type == 1) {
            this.iconList = res.List
          }
        })
      } catch (e) {
        console.log(e)
      }
    },
    returnIconImage(icon) {
      return icon.hasOwnProperty('Files') ? `${icon.Files[0].org_url}?${this.setImageOptions(54, 54, 'png')}` : ''
    },
    movePage(icon) {
      window.location.href(icon.url)
    },
    openUrl(url) {
      if (!util.isEmpty(url)) {
        if (url.includes('https://') || url.includes('http://')) {
          window.open(url, '_blank')
        }else{
          window.open(`http://${url}`, '_blank')
        }
      }
    }
  },
  watch: {}
}
</script>

<style scoped>

</style>